import React, { Fragment, Component } from 'react';

class DocumentsContainer extends Component {
  public componentDidMount() : void {
    const param = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    const pdfUrl = `/files/ECI/${param}.pdf`;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public render() : JSX.Element {
    return <Fragment></Fragment>;
  }
}

export default DocumentsContainer;
